import SectionHeading from './SectionHeading'

const cards = [
    {
        title: 'Mail Gets Seen — Not Scrolled Past',
        body: 'Homeowners ignore ads, block calls, and skip sponsored posts. But your postcard sits on the kitchen counter for days—reminding them who to call when the roof leaks or the next storm hits.',
        variant: 'accent',
        Icon: () => (
            <svg
                width="102"
                height="102"
                viewBox="0 0 102 102"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_7_303)">
                    <circle cx="51" cy="43" r="41" fill="white" />
                    <circle cx="51" cy="43" r="40.5" stroke="#DCDCDC" />
                </g>
                <path
                    d="M46.6667 57V46.1667C46.6667 44.6196 46.0521 43.1358 44.9581 42.0419C43.8642 40.9479 42.3804 40.3333 40.8333 40.3333M40.8333 40.3333C39.2862 40.3333 37.8025 40.9479 36.7085 42.0419C35.6146 43.1358 35 44.6196 35 46.1667V57H65V47C65 45.2319 64.2976 43.5362 63.0474 42.286C61.7971 41.0357 60.1014 40.3333 58.3333 40.3333H40.8333ZM50 40.3333V27H56.6667L60 30.3333L56.6667 33.6667H50M40 47H41.6667"
                    stroke="url(#paint0_linear_7_303)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <defs>
                    <filter
                        id="filter0_d_7_303"
                        x="0"
                        y="0"
                        width="102"
                        height="102"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="8" />
                        <feGaussianBlur stdDeviation="5" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_7_303"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_7_303"
                            result="shape"
                        />
                    </filter>
                    <linearGradient
                        id="paint0_linear_7_303"
                        x1="65"
                        y1="57"
                        x2="30.6497"
                        y2="33.3071"
                        gradientUnits="userSpaceOnUse">
                        <stop stopColor="#FAB132" />
                        <stop offset="1" stopColor="#F15A22" />
                    </linearGradient>
                </defs>
            </svg>
        ),
    },
    {
        title: 'Higher ROI Than Digital Ads',
        body: 'While roofers spend hundreds on PPC clicks that never call back, direct mail delivers qualified homeowners who are actively thinking about repairs or replacements resulting in contracts, not just “leads.”',
        variant: 'neutral',
        Icon: () => (
            <svg
                width="102"
                height="102"
                viewBox="0 0 102 102"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_7_307)">
                    <circle cx="51" cy="43" r="41" fill="white" />
                    <circle cx="51" cy="43" r="40.5" stroke="#DCDCDC" />
                </g>
                <path
                    d="M46 46.3333C46 49.095 50.4767 51.3333 56 51.3333C61.5233 51.3333 66 49.095 66 46.3333M46 46.3333C46 43.5717 50.4767 41.3333 56 41.3333C61.5233 41.3333 66 43.5717 66 46.3333M46 46.3333V53C46 55.76 50.4767 58 56 58C61.5233 58 66 55.76 66 53V46.3333M36 33C36 34.7867 37.9067 36.4367 41 37.33C44.0933 38.2233 47.9067 38.2233 51 37.33C54.0933 36.4367 56 34.7867 56 33C56 31.2133 54.0933 29.5633 51 28.67C47.9067 27.7767 44.0933 27.7767 41 28.67C37.9067 29.5633 36 31.2133 36 33ZM36 33V49.6667C36 51.1467 37.2867 52.0833 39.3333 53M36 41.3333C36 42.8133 37.2867 43.75 39.3333 44.6667"
                    stroke="url(#paint0_linear_7_307)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <defs>
                    <filter
                        id="filter0_d_7_307"
                        x="0"
                        y="0"
                        width="102"
                        height="102"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="8" />
                        <feGaussianBlur stdDeviation="5" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_7_307"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_7_307"
                            result="shape"
                        />
                    </filter>
                    <linearGradient
                        id="paint0_linear_7_307"
                        x1="66"
                        y1="58"
                        x2="31.6497"
                        y2="34.3071"
                        gradientUnits="userSpaceOnUse">
                        <stop stopColor="#FAB132" />
                        <stop offset="1" stopColor="#F15A22" />
                    </linearGradient>
                </defs>
            </svg>
        ),
    },
    {
        title: 'Speed That Matches Storm Demand',
        body: 'When a storm hits, timing is everything. OLM gets your mailers into mailboxes within 48 hours, so you’re the first roofer homeowners think of.',
        variant: 'neutral',
        Icon: () => (
            <svg
                width="102"
                height="102"
                viewBox="0 0 102 102"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_7_308)">
                    <circle cx="51" cy="43" r="41" fill="white" />
                    <circle cx="51" cy="43" r="40.5" stroke="#DCDCDC" />
                </g>
                <path
                    d="M51.6667 28V39.6667H61.6667L48.3333 58V46.3333H38.3333L51.6667 28Z"
                    stroke="url(#paint0_linear_7_308)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <defs>
                    <filter
                        id="filter0_d_7_308"
                        x="0"
                        y="0"
                        width="102"
                        height="102"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="8" />
                        <feGaussianBlur stdDeviation="5" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_7_308"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_7_308"
                            result="shape"
                        />
                    </filter>
                    <linearGradient
                        id="paint0_linear_7_308"
                        x1="61.6667"
                        y1="58"
                        x2="31.0505"
                        y2="41.5754"
                        gradientUnits="userSpaceOnUse">
                        <stop stopColor="#FAB132" />
                        <stop offset="1" stopColor="#F15A22" />
                    </linearGradient>
                </defs>
            </svg>
        ),
    },
    {
        title: 'Target Only the Right Homes',
        body: 'Use storm-path data and high-equity homeowner lists to reach the homes most likely to need roofing services—no wasted spend, just targeted mail to the right neighborhoods at the right time.',
        variant: 'accent',
        Icon: () => (
            <svg
                width="102"
                height="102"
                viewBox="0 0 102 102"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_7_309)">
                    <circle cx="51" cy="43" r="41" fill="white" />
                    <circle cx="51" cy="43" r="40.5" stroke="#DCDCDC" />
                </g>
                <path
                    d="M51 34.6667C49.3518 34.6667 47.7407 35.1554 46.3703 36.0711C44.9999 36.9868 43.9318 38.2883 43.301 39.811C42.6703 41.3337 42.5053 43.0092 42.8268 44.6258C43.1484 46.2423 43.942 47.7271 45.1075 48.8926C46.2729 50.058 47.7578 50.8517 49.3743 51.1732C50.9908 51.4948 52.6663 51.3297 54.189 50.699C55.7118 50.0683 57.0133 49.0002 57.9289 47.6298C58.8446 46.2593 59.3334 44.6482 59.3334 43M52.6667 28.0917C49.5768 27.745 46.4555 28.3672 43.7347 29.872C41.0138 31.3768 38.8278 33.69 37.4791 36.4915C36.1303 39.293 35.6855 42.4444 36.2061 45.5098C36.7267 48.5751 38.187 51.403 40.3851 53.6021C42.5831 55.8013 45.4102 57.263 48.4753 57.7852C51.5404 58.3073 54.6921 57.8641 57.4942 56.5167C60.2964 55.1694 62.6107 52.9846 64.1169 50.2645C65.6231 47.5444 66.2468 44.4234 65.9017 41.3334M56 38V33L61 28V33H66L61 38H56ZM56 38L51 43M49.3334 43C49.3334 43.442 49.5089 43.8659 49.8215 44.1785C50.1341 44.4911 50.558 44.6667 51 44.6667C51.442 44.6667 51.866 44.4911 52.1785 44.1785C52.4911 43.8659 52.6667 43.442 52.6667 43C52.6667 42.558 52.4911 42.134 52.1785 41.8215C51.866 41.5089 51.442 41.3333 51 41.3333C50.558 41.3333 50.1341 41.5089 49.8215 41.8215C49.5089 42.134 49.3334 42.558 49.3334 43Z"
                    stroke="url(#paint0_linear_7_309)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <defs>
                    <filter
                        id="filter0_d_7_309"
                        x="0"
                        y="0"
                        width="102"
                        height="102"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="8" />
                        <feGaussianBlur stdDeviation="5" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_7_309"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_7_309"
                            result="shape"
                        />
                    </filter>
                    <linearGradient
                        id="paint0_linear_7_309"
                        x1="66"
                        y1="57.9982"
                        x2="31.6474"
                        y2="34.2992"
                        gradientUnits="userSpaceOnUse">
                        <stop stopColor="#FAB132" />
                        <stop offset="1" stopColor="#F15A22" />
                    </linearGradient>
                </defs>
            </svg>
        ),
    },
]

function IconBadge({ Icon }) {
    return (
        <div
            className={[
                'absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2',
                'lg:left-0 lg:top-1/2 lg:-translate-y-1/2 lg:-translate-x-1/2',
                'w-20 h-20',
                'rounded-full flex items-center justify-center',
                'transform',
                'z-20',
            ].join(' ')}>
            <Icon />
        </div>
    )
}

function InfoCard({ title, body, Icon, variant, order }) {
    const accent = variant === 'accent'
    return (
        <div
            className={[
                'relative',
                order,
                'rounded-[12px] px-6 pt-14 pb-8 sm:px-8 sm:pt-9 sm:pb-9 lg:pl-14',
                'shadow-[0px_20px_60px_rgba(15,23,42,0.12)]',
                accent
                    ? 'bg-[linear-gradient(90deg,#F15A22_0%,#FAB132_100%)] text-white'
                    : 'bg-white text-olm-black',
            ].join(' ')}>
            <IconBadge Icon={Icon} accent={accent} />
            <h3 className="text-xl font-semibold mb-3 pr-2">{title}</h3>
            <p
                className={[
                    'text-base leading-relaxed',
                    accent ? 'text-white/90' : 'text-olm-black/80',
                ].join(' ')}>
                {body}
            </p>
        </div>
    )
}

export default function WhyDirectMail() {
    return (
        <section className="bg-[linear-gradient(180deg,#FFFFFF_0%,#FFF8EA_100%)] py-16 sm:py-20">
            <div className="container mx-auto px-4">
                <div className="max-w-3xl mx-auto text-center">
                    <SectionHeading textAlignment="text-center">
                        Why Top{' '}
                        <span className="text-olm">Roofing Companies</span> Rely
                        On Direct Mail
                    </SectionHeading>
                    <p className="mt-5 text-base sm:text-lg lg:text-xl text-gray-600">
                        Homeowners scroll past ads every day—there&apos;s too
                        much digital noise, too many pop-ups, and too many
                        brands fighting for attention. But they still check
                        their mailbox. Direct mail gives roofers something
                        digital can&apos;t: attention that lasts, trust that
                        feels personal, and leads that turn into contracts.
                    </p>
                </div>

                <div className="mt-12 grid gap-12 lg:grid-cols-2 max-w-5xl mx-auto pt-12 lg:pt-0 lg:pl-12 lg:pr-12">
                    {cards.map((card, index) => {
                        // On mobile/tablet: move second-to-last card (index 2) to last position
                        // Order: 1, 2, 4, 3 (on mobile/tablet) -> 1, 2, 3, 4 (on desktop)
                        let order = ''
                        if (index === 0) {
                            order = 'order-1 lg:order-1'
                        } else if (index === 1) {
                            order = 'order-2 lg:order-2'
                        } else if (index === 2) {
                            order = 'order-4 lg:order-3' // Second-to-last becomes last on mobile/tablet
                        } else if (index === 3) {
                            order = 'order-3 lg:order-4' // Last becomes second-to-last on mobile/tablet
                        }
                        return (
                            <InfoCard
                                key={card.title}
                                {...card}
                                order={order}
                            />
                        )
                    })}
                </div>
            </div>
        </section>
    )
}
